import {
  DEFAULT_SIDER_WIDTH,
  getStoredSiderWidth,
  MAX_SIDER_WIDTH,
  MIN_SIDER_WIDTH,
  SIDER_WIDTH_STORAGE_KEY,
  SiderResizeHandle,
} from '@zhiyue/core';

export {
  DEFAULT_SIDER_WIDTH,
  MAX_SIDER_WIDTH,
  MIN_SIDER_WIDTH,
  SIDER_WIDTH_STORAGE_KEY,
  getStoredSiderWidth,
};

export default SiderResizeHandle;
